<template>
  <div class="alert-wrapper">
    <div class="vote-bg-box">
      <img class="vote-bg" :src="require('../../assets/imgs/vote/vote_bg.png')" alt="">
    </div>
    <div class="content-box">
      <div class="title">{{voteTitle}}</div>
      <img class="vote-btn vote-a" :src="require('../../assets/imgs/vote/vote_A.png')" alt="" @click="onClickVote(1)">
      <img class="vote-btn vote-b" :src="require('../../assets/imgs/vote/vote_B.png')" alt="" @click="onClickVote(2)">
    </div>
  </div>
</template>

<script>
  export default {
    name: "VoteAlert",
    props: {
      voteTitle: {
        type: String,
        default: ''
      }
    },
    data() {
      return {
      };
    },
    methods: {
      onClickVote(viewpoint) {
        this.$emit("onClickVote", viewpoint);
      }
    }
  };
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .alert-wrapper {
    width calc(100vw - 20px)
    height calc((100vw - 20px) * 485 / 345)
    max-height 80vh
    box-sizing border-box
    border-radius 12px
    font-family serif,SimSun,STSong

    .vote-bg-box {
      border-radius 12px
      width 100%
      height 100%
      position absolute
      overflow hidden
      
      .vote-bg {
        width 100%
      }
    }

    .content-box {
      position absolute
      width 100%
      height 100%
      display flex
      flex-direction column
      align-items center
      justify-content flex-end

      .title {
        color #03ADFF
        font-size 18px
        font-weight bold
        text-align center
        padding 0 33px
      }

      .vote-btn {
        width calc(100% - 66px)
      }

      .vote-a {
        margin-top 50px
      }

      .vote-b {
        margin-top 16px
        margin-bottom 33px
      }
        
    }
  }
</style>


// WEBPACK FOOTER //
// app/components/vote/VoteAlert.vue